module.exports = __webpack_public_path__ + "static/media/book-cover.14689756.png";